window.addEventListener('DOMContentLoaded', function() {
    console.log('ebru pages loaded!');

    const disableClass = 'mydisable';

    const disableTag = (id) => {
        const tag = document.getElementById(id);
        if (tag.classList.contains(disableClass))
            return;
        tag.classList.add(disableClass);
    };

    const visibleTag = (id) => {
        const tag = document.getElementById(id);
        if (!tag.classList.contains(disableClass))
            return;
        tag.classList.remove(disableClass);
    };

    const targets = {
        faceplate: 'pages-works-faceplate',
        earmonitor: 'pages-works-earmonitor',
        sound: 'pages-works-sound'
    };

    const images = {
        default: 'pages-works-default-image',
        faceplate: 'pages-works-faceplate-image',
        earmonitor: 'pages-works-earmonitor-image',
        sound: 'pages-works-sound-image'
    };

    const description = {
        default: 'pages-works-default-description',
        faceplate: 'pages-works-faceplate-description',
        earmonitor: 'pages-works-earmonitor-description',
        sound: 'pages-works-sound-description'
    };

    const reset = () => {
        console.log("reset!!")
            // default
        disableTag(images.faceplate);
        disableTag(images.earmonitor);
        disableTag(images.sound);
        disableTag(description.faceplate);
        disableTag(description.earmonitor);
        disableTag(description.sound);
        visibleTag(images.default);
        visibleTag(description.default);
        //faceplate
        // disableTag(images.default);
        // disableTag(images.earmonitor);
        // disableTag(images.sound);
        // disableTag(description.default);
        // disableTag(description.earmonitor);
        // disableTag(description.sound);
        // visibleTag(images.faceplate);
        // visibleTag(description.faceplate);
    };

    const faceplateTag = document.getElementById(targets.faceplate);
    const earmonitorTag = document.getElementById(targets.earmonitor);
    const soundTag = document.getElementById(targets.sound);
    //reset action
    if (faceplateTag) faceplateTag.addEventListener('mouseleave', reset, false);
    if (earmonitorTag) earmonitorTag.addEventListener('mouseleave', reset, false);
    if (soundTag) soundTag.addEventListener('mouseleave', reset, false);

    if (faceplateTag) faceplateTag.addEventListener('mouseenter', () => {
        console.log('in');
        disableTag(images.default);
        disableTag(images.earmonitor);
        disableTag(images.sound);
        disableTag(description.default);
        disableTag(description.earmonitor);
        disableTag(description.sound);
        visibleTag(images.faceplate);
        visibleTag(description.faceplate);
    }, false);

    if (earmonitorTag) earmonitorTag.addEventListener('mouseenter', () => {
        console.log('in');
        disableTag(images.default);
        disableTag(images.faceplate);
        disableTag(images.sound);
        disableTag(description.default);
        disableTag(description.faceplate);
        disableTag(description.sound);
        visibleTag(images.earmonitor);
        visibleTag(description.earmonitor);
    }, false);

    if (soundTag) soundTag.addEventListener('mouseenter', () => {
        console.log('in');
        disableTag(images.default);
        disableTag(images.earmonitor);
        disableTag(images.faceplate);
        disableTag(description.default);
        disableTag(description.earmonitor);
        disableTag(description.faceplate);
        visibleTag(images.sound);
        visibleTag(description.sound);
    }, false);

    let readmoreHistory = document.querySelector(".pages-artists-history");
    let readmoreMusic = document.querySelector(".pages-artists-music");
    let musicContent = document.querySelector(".pages-artists-music-content");
    let historyContent = document.querySelector(".pages-artists-history-content")
    const closeTxt = "× Close";

    let click_history = () => {
        if (historyContent.style.display === "none") {
            historyContent.style.display = "block";
            readmoreHistory.innerText = closeTxt;
        } else {
            historyContent.style.display = "none";
            readmoreHistory.innerText = "Read more";
        }
    };

    let click_music = () => {
        if (musicContent.style.display === "none") {
            musicContent.style.display = "block";
            readmoreMusic.innerText = closeTxt;
        } else {
            musicContent.style.display = "none";
            readmoreMusic.innerText = "Read more ♪";
        }
    };

    if (readmoreHistory) readmoreHistory.addEventListener("click", click_history);
    if (readmoreMusic) readmoreMusic.addEventListener("click", click_music);
});